import { createSelector } from '@reduxjs/toolkit';
import { selectOfferLevelSelectedDate as selectCrossSellStartDate, selectPassengerOption } from 'component/page/detail/store/availabilitySelectorIndex';
import { selectDetailState } from 'component/page/detail/store/detail.selectors';
import { PaxTypeCode } from 'gql/autogen/PaxTypeCode';
import { mapActivityContentForDetail } from 'gql/service/graph/activityService';
import { addDays } from 'date-fns';

const activityChildrenPaxTypeCode = [PaxTypeCode.INFANT, PaxTypeCode.CHILD, PaxTypeCode.YOUTH, PaxTypeCode.TODDLER];

export const selectNumberOfAdults = createSelector(selectPassengerOption, (passengers) =>
    passengers.filter((pax) => !activityChildrenPaxTypeCode.includes(pax.code as PaxTypeCode)).reduce((sum, pax) => sum + pax.quantity.value, 0),
);

export const selectNumberOfChildren = createSelector(selectPassengerOption, (passengers) =>
    passengers.filter((pax) => activityChildrenPaxTypeCode.includes(pax.code as PaxTypeCode)).reduce((sum, pax) => sum + pax.quantity.value, 0),
);

export const selectCrossSellOccupancy = createSelector(selectNumberOfAdults, selectNumberOfChildren, (numberOfAdults, numberOfChildren) => {
    return {
        adults: numberOfAdults,
        children: numberOfChildren,
    };
});

export const selectCrossSellEndDate = createSelector(selectCrossSellStartDate, (startDate) => {
    return addDays(startDate, 1);
});

export const selectCrossSellDateInterval = createSelector(selectCrossSellStartDate, selectCrossSellEndDate, (startDate, endDate): { startDate: Date; endDate: Date } => {
    return { startDate, endDate };
});

export const selectCrossSellDestination = createSelector(selectDetailState, (detailState) => {
    const result = mapActivityContentForDetail(detailState);
    const cityId = result.activity?.location?.city?.id;
    const cityName = result.activity?.location?.city?.name;

    if (cityId && cityName) return { cityId, cityName };
    return null;
});
